import React from 'react';
import { Link } from 'react-router-dom';
import { getMapsUnavailableContent } from '../api/mapsConfig';

/**
 * Shown when Google Maps cannot load — permit workflows remain available.
 */
const MapsUnavailable = ({
  loadError,
  title,
  compact = false,
  showActions = true,
}) => {
  const content = getMapsUnavailableContent({ loadError });
  const heading = title || content.title;

  return (
    <div
      className={`rhs-maps-unavailable${compact ? ' rhs-maps-unavailable--compact' : ''}`}
      role="status"
      aria-live="polite"
    >
      <div className="rhs-maps-unavailable-icon" aria-hidden="true">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
            fill="currentColor"
            opacity="0.35"
          />
          <path
            d="M3 20h18"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            opacity="0.5"
          />
        </svg>
      </div>

      <div className="rhs-maps-unavailable-body">
        <h3 className="rhs-maps-unavailable-title">{heading}</h3>
        <p className="rhs-maps-unavailable-summary">{content.summary}</p>

        {content.steps?.length > 0 && (
          <ul className="rhs-maps-unavailable-steps">
            {content.steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ul>
        )}

        {showActions && (
          <div className="rhs-maps-unavailable-actions">
            <Link to="/dashboard" className="rhs-btn rhs-btn--sm">
              Dashboard
            </Link>
            <Link to="/permit-history" className="rhs-btn rhs-btn--secondary rhs-btn--sm">
              Permit history
            </Link>
            <Link to="/permit" className="rhs-btn rhs-btn--outline rhs-btn--sm">
              Submit with coordinates
            </Link>
          </div>
        )}

        {content.adminHint && !compact && (
          <details className="rhs-maps-unavailable-admin">
            <summary>Administrator setup</summary>
            <p>{content.adminHint}</p>
          </details>
        )}
      </div>
    </div>
  );
};

export default MapsUnavailable;
